// @flow strict

export const HEALTH = 'Health';
export const HIOS_ID = 'HIOS ID';
export const PLAN_YEAR = 'Plan Year';
export const STRIDE_PLAN_ID = 'Stride Plan ID';
export const SUBSIDY_AMOUNT = 'Subsidy Amount';
